// Snap a raycast hit point to the nearest mesh vertex within threshold.
// Returns the hit point itself if no vertex is close enough.
export function snapToVertex(hit, threshold) {
  const mesh = hit.object;
  const pos  = mesh.geometry.attributes.position;
  if (!pos) return hit.point;

  const worldPos = hit.point.clone();
  let   bestDist = threshold;
  let   best     = hit.point.clone();

  for (let i = 0; i < pos.count; i++) {
    worldPos.set(pos.getX(i), pos.getY(i), pos.getZ(i));
    worldPos.applyMatrix4(mesh.matrixWorld);
    const d = worldPos.distanceTo(hit.point);
    if (d < bestDist) { bestDist = d; best = worldPos.clone(); }
  }
  return best;
}

// Flatten a nested object into dot-notation key/value pairs for the
// properties panel. Handles { value: x } wrappers from iTwin property bags.
export function flattenProps(props) {
  if (!props) return {};
  const out = {};
  const add = (obj, prefix = "") => {
    for (const [k, v] of Object.entries(obj)) {
      if (v === null || v === undefined) continue;
      if (typeof v === "object" && !Array.isArray(v)) {
        if (v.value !== undefined) out[prefix + k] = v.value;
        else add(v, prefix + k + ".");
      } else if (!Array.isArray(v)) {
        out[prefix + k] = v;
      }
    }
  };
  add(props);
  return out;
}

// Sync orthographic camera frustum to match the perspective FOV at the
// current orbit distance. Call on: resize, camera switch, view preset,
// window zoom, and every frame while in ortho mode.
export function syncOrthoFrustum(orthoCamera, controls, viewW, viewH) {
  const dist  = Math.max(orthoCamera.position.distanceTo(controls.target), 0.1);
  const halfH = dist * Math.tan((55 / 2) * (Math.PI / 180));
  const halfW = halfH * (viewW / viewH);
  orthoCamera.left   = -halfW;
  orthoCamera.right  =  halfW;
  orthoCamera.top    =  halfH;
  orthoCamera.bottom = -halfH;
  orthoCamera.updateProjectionMatrix();
}

// Format a distance value (in model units, assumed meters) to a readable string.
export function formatDistance(distanceM) {
  if (distanceM >= 1) return { dist: distanceM.toFixed(3), unit: "m" };
  return { dist: (distanceM * 1000).toFixed(1), unit: "mm" };
}
